import { getRequestContext } from '../context';

const PROD_TEMPORAL_BASE_URL = 'https://shopify.temporal.yandex-team.ru/namespaces/alty/workflows';
const TEST_TEMPORAL_BASE_URL = 'https://agate.temporal.yandex-team.ru/namespaces/alty_test/workflows';
const DEV_TEMPORAL_BASE_URL = 'https://agate.temporal.yandex-team.ru/namespaces/alty_dev/workflows';

export const getAltyTemporalBaseUrl = () => {
    const requestContext = getRequestContext();
    const { env } = requestContext;

    if (env === 'production') {
        return PROD_TEMPORAL_BASE_URL;
    } else if (env === 'prestable') {
        return TEST_TEMPORAL_BASE_URL;
    }

    return DEV_TEMPORAL_BASE_URL;
};
